// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import "@stimulus/polyfills"
require("controllers")
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import '../js/bootstrap_js_files.js' 
import "../js/components"
import * as FormValidation from '../js/formvalidation';
import debounced from 'debounced'
debounced.initialize({ click: { wait: 500 } })
global.FormValidation = FormValidation;
import Bootstrap5 from '../js/formvalidation/plugins/Bootstrap5';
import AutoFocus from '../js/formvalidation/plugins/AutoFocus';
import Trigger from '../js/formvalidation/plugins/Trigger';
import Chart from 'chart.js/auto';
global.Chart = Chart;
global.AutoFocus = AutoFocus;
global.Bootstrap5 = Bootstrap5;
global.Trigger = Trigger;
import moment from 'moment-timezone';
window.moment = moment;
global.sinon = require("sinon/lib/sinon/util/fake-timers");
import { library, dom, config } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { faChevronLeft, faChevronRight, faTimes, faUniversalAccess, faSmile, faWifi, faUser, faUsers, faUserCheck, faUserClock, faPhone, faToggleOn, faPencilAlt, faCalendar, faCalendarAlt, faSearch, faAdjust, faSort, faPlus, faTrash, faExclamation, faPlay, faPause, faArrowRight, faPhoneSlash, faShare, faPhoneAlt, faShieldAlt, faClock, faFileAudio, faFont, faExternalLinkAlt, faChevronDown } from '@fortawesome/free-solid-svg-icons';
library.add( faChevronLeft, faChevronRight, faTimes, faUniversalAccess, faSmile, faWifi, faUser, faUsers, faUserCheck, faUserClock, faPhone, faToggleOn, faPencilAlt, faCalendar, faCalendarAlt, faSearch, faAdjust, faSort, faPlus, faTrash, faExclamation, faPlay, faPause, faArrowRight, faPhoneSlash, faShare, faPhoneAlt, faShieldAlt, faClock, faFileAudio, faFont, faExternalLinkAlt, faChevronDown )
library.add(fas)
dom.watch()
config.autoReplaceSvg = 'nest';
config.mutateApproach = 'sync';
import Choices from 'choices.js';
import 'choices.js/public/assets/styles/choices.css'; // Import CSS for Choices.js



Rails.start()
Turbolinks.start()
ActiveStorage.start()
import "controllers"
import "components"

import flatpickr from "flatpickr";

